<template>
	<div>
		<van-nav-bar
			:title="navTitle"
			left-text="返回"
			left-arrow
			@click-left="onLeftClick"
		/>
		<van-grid :column-num="2" class="grid-cabinet">
			<van-grid-item v-for="d in orders" v-bind:key="d.id">
				<van-image radius="10" class="img-book-cover" :src="d.cover" />
				<div class="book-name">
					{{ d.bookName }}
					<van-goods-action-icon
						v-if="d.wishId != '' && d.wishId != undefined"
						icon="star"
						text="已收藏"
						color="#ff5000"
					/>
					<van-goods-action-icon
						v-if="!(d.wishId != '' && d.wishId != undefined)"
						icon="star"
						text="收藏"
						color="#EEEEEE"
					/>
				</div>
			</van-grid-item>
		</van-grid>
	</div>
</template>

<script>
import {
	Grid,
	GridItem,
	NavBar,
	Image as VanImage,
	GoodsActionIcon,
} from "vant";

import { Post } from "@/utils/Api";

export default {
	components: {
		[Grid.name]: Grid,
		[GridItem.name]: GridItem,
		[NavBar.name]: NavBar,
		[VanImage.name]: VanImage,
		[VanImage.name]: VanImage,
		[GoodsActionIcon.name]: GoodsActionIcon,
	},

	data() {
		return {
			openId: null,
			cabnet: null,
			navTitle: "",
			orders: [],
			wishes: [],
		};
	},

	mounted() {
		this.openId = localStorage.getItem("openId");
		this.cabnet = this.$route.params.cabnet;
		this.navTitle =
			"[" + this.cabnet.schoolName + "." + this.cabnet.number + "号书柜]详情";

		this.loadOrders();
		this.loadWishes();
	},

	methods: {
		onLeftClick() {
			this.$router.push({ name: "home" });
		},
		loadOrders() {
			Post(
				"order/querySendedOrderByCabinetNumber",
				{
					cabinetNumber: this.cabnet.number,
					openId: this.openId,
				},
				(r) => {
					//console.log("order/querySendedOrderByCabinetNumber", r);
					var data = r.data.data;
					console.log(data);
				},
				(r) => {
					console.log(r);
				}
			);
		},
		loadWishes() {
			Post(
				"queryWish",
				{
					openId: this.openId,
				},
				(res) => {
					console.log("load wishes", res.data.data);
					this.wishes = res.data.data;
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
	},
};
</script>

<style lang="less"></style>
